function _deleteTooltip(id) {
  const tooltip = document.getElementById(id);
  tooltip && tooltip.remove();
}

function createTooltipPlugin() {
  Alpine.directive("tooltip", (el, { value, modifiers, expression }, { Alpine, effect, cleanup, evaluate }) => {
    let tooltipContainer, isWhiteTheme;
    const tooltipId = evaluate("$id('tooltip')");

    isWhiteTheme = modifiers.includes("theme") && modifiers[modifiers.indexOf("theme") + 1] === "white";
    const themeStyle = isWhiteTheme ? "bg-white text-black" : "bg-black text-white";

    const tooltipHTML = `<div x-data="{show: false}" x-show="show" x-transition.duration.300ms x-transition.delay.300ms x-cloak x-anchor.${modifiers.join(".")}="document.querySelector('[data-tooltip=${tooltipId}]')"  x-init="setTimeout(function(){ show = true; }, 1);" id="${tooltipId}"class="z-10000 absolute px-2 py-1 rounded-md shadow-xs ${themeStyle}">${expression}</div>`;

    if (!(tooltipContainer = document.querySelector("[data-tooltip-container]"))) {
      tooltipContainer = document.createElement("div");
      tooltipContainer.dataset.tooltipContainer = true;
      document.body.appendChild(tooltipContainer);
    }

    let pointerEnter = function (event) {
      if (!window.matchMedia("(hover: hover)").matches) return;

      if (event.pointerType === "touch") return;

      tooltipContainer.innerHTML = tooltipHTML;
    };

    let pointerLeave = function (event) {
      _deleteTooltip(event.target.dataset.tooltip);
    };

    let click = function (event) {
      _deleteTooltip(event.target.closest("[data-tooltip]").dataset.tooltip);
    };

    el.dataset.tooltip = tooltipId;

    el.addEventListener("pointerenter", pointerEnter);
    el.addEventListener("pointerleave", pointerLeave);
    // el.addEventListener("touchstart", touchStart, { passive: true });
    el.addEventListener("click", click);

    cleanup(() => {
      el.removeEventListener("pointerenter", pointerEnter);
      el.removeEventListener("pointerleave", pointerLeave);
      // el.removeEventListener("touchstart", touchStart);
      el.removeEventListener("click", click);
    });
  });
}

export { createTooltipPlugin };
